<template>
  
      <div id="map" style="position: sticky">
      </div>

    
</template>

<script>
  import L from "leaflet";
  import 'leaflet.markercluster';
  import 'leaflet.markercluster/dist/MarkerCluster.css';

  export default {
    name: 'Map',

    data(){
      return {
        map: null,
        featuregroup: null,
        tileLayer: null,
        json: [],
        url: undefined,
        markers: [],
        center:[],
        mcg: null,
      }
    },
    mounted: function () {

        this.$root.$on('newUrl',(url) => {
          this.url = url;
        });

        this.initMap();
        this.url = 'https://eventinfo.kodus.dk/api/events/fyn';
        

    },
    updated: function () {
        this.$nextTick(function () {

        })
      }
    ,
    watch: {
      url(val) {
        this.getData(val);
      },
    
    },
    methods: {
       async getData(){
          const url = this.url;
          const response = await fetch(url);
          const json = await response.json();
          this.json = await json;
          
          //Besked om ingen results, hvis svar er tomt.
          if (Array.isArray(this.json) && this.json.length){
            await this.initMarkers();
            if(parseInt(this.$vuetify.breakpoint.width) < 600){
              this.$root.$emit('closeDrawer',true);
            }
            
            this.$root.$emit('noresult',false);

          }
          else{
            this.$root.$emit('noresult',true);
          }       
      },
      initMap(){
        var tiles = L.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            attribution: '&copy; <a href="//openstreetmap.org/copyright">OpenStreetMap</a> Af Rune Heidtmann'
          });

          this.map = L.map('map', {
            center: L.latLng(55.58, 11.46),
            zoom: 8,
            layers: [tiles]
          });
          
      },
      initMarkers(){
         if(this.mcg != null){
           this.mcg.clearLayers();
         }
         
         this.mcg = L.markerClusterGroup({
            chunkedLoading: true,
            //singleMarkerMode: true,
            spiderfyOnMaxZoom: true
          });

          var latlng = []

          this.json.forEach(marker => {
            
            if(marker.lat != null){
              var lat = marker.lat;
              var lng = marker.lng;
              var thetime = marker.event_time_start ? `kl. ${this.formatTime(marker.event_time_start)}` : ""
              var popup = `<div class="mapContainer">
                          ${this.pasteImg(marker.image_src)}
                          <h1 class="mapRubrik">${marker.rubrik}</h1>
                          <h3 class="mapLabel">${marker.event_kategori}:</h3><time class="mapDate">${this.formatDate(marker.event_dato)} ${thetime} </time>
                          <p class="mapContent">
                            ${(marker.mere_om == null ? " " : marker.mere_om) }
                          </p>
                          <p class="mapContent">
                           Arrangementet for ${marker.maalgruppe}.
                          </p>
                          <p class="mapContent">${this.pasteLink(marker.link)}</p>
                          <p class="mapContent">
                            ${marker.adresselinje},
                            ${marker.postNr}
                          </p>
                          </div>`;
              
              
              var marks = L.marker(new L.LatLng(lat, lng));
              marks.bindPopup(popup, {maxWidth : 275});
              this.mcg.addLayer(marks);
              latlng.push([lat, lng])
            }
          });

          this.map.addLayer(this.mcg);
          var bounds = new L.LatLngBounds(latlng);
          this.map.fitBounds(bounds,{
            maxZoom: 14,
            duration: 1,
          }); 
      },
       formatDate(datestring){
        let date = new Date(datestring)
        let mm = date.getMonth()
        let dd = date.getDate()
        let day = date.getDay()
        //let yyyy = date.getFullYear()
        var months = ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"];
        var days = ['Søn','Man','Tirs','Ons','Tors','Fre','Lør']

        date = days[day]+" d. "+ dd+". "+months[mm]

        return date
      },
      formatTime(time){
        return time.slice(0, 5)
      },
      pasteImg(imgSrc){
        if(imgSrc != null){
          let string = `<img width = "100%" src="${imgSrc}">`;
          return string;
        }
        else
          return "";
      },
      pasteLink(url){
         if(url != null){
            let string = `<a href="${url}" target="_blank">Læs mere og køb billet her</a>`;
          return string;
        }
        else
          return "";
      },
    }
  }
</script>
<style>

.mapContainer{
  max-height: 450px;
  overflow-y: auto;
}
.mapDate{
    font-size: 0.9rem;
    color: #736f6b;
    font-family: 'Roboto', sans-serif;
    vertical-align: baseline;
}
.mapLabel{
    color: #03A9F4;
    display: inline-block;
    font-family: "Roboto Condensed",sans-serif;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
    margin-right: 10px;
}
.mapRubrik {
    font-size: 1.4rem;
    line-height: 1.35;
    margin-top: .3rem;
    color: #474340;
    font-family: "Roboto Condensed",sans-serif;
    margin-bottom: 3px;
}
.mapContent{
  font-size: 1rem;
    line-height: 1.6;
    font-family: Lora,serif;

}
</style>
<style scoped>
#map {
        height: 100%;  /* The height is 400 pixels */
        width: 100%;  /* The width is the width of the web page */
        position: sticky;
       }
.leaflet-container{
  position: sticky;
}

</style>
<style>
#content{
  width: 200px;
}
a:link, a:visited{
  color: #e65100;
}

</style>
